import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { SF_Picker } from "./AdminLayout";

export default function AdminImages() {
  const [sf, setSf] = useState("jewelry");
  const [images, setImages] = useState([]);

  useEffect(() => { api.get(`/admin/images/${sf}`).then((r) => setImages(r.data)).catch(() => setImages([])); }, [sf]);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-serif text-3xl">Site Images</h1>
        <SF_Picker value={sf} onChange={setSf} />
      </div>
      <p className="text-sm text-neutral-500 mb-6">Every customer-facing image used by the <strong className="capitalize">{sf}</strong> storefront. Replace any image from its source section in Content & Pages (homepage, navigation, collections) or in the Product editor.</p>
      {images.length === 0 ? (
        <div className="bg-white border border-neutral-200 rounded-lg p-16 text-center text-neutral-500">No images uploaded yet.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {images.map((img, i) => (
            <div key={i} data-testid={`site-image-${i}`} className="bg-white border border-neutral-200 rounded-lg overflow-hidden">
              <div className="aspect-[3/4] bg-neutral-100"><img src={img.url} alt={img.section} loading="lazy" className="w-full h-full object-cover" /></div>
              <div className="p-2 text-[0.68rem] text-neutral-500">{img.section}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
